import * as React from 'react';

import classnames from 'classnames';

import type {Color} from './body';

import styles from './section-label.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
    noBottomBorder?: boolean;
    noBottomMargin?: boolean;
    htmlFor?: string;
    size?: 'mini' | 'small' | 'normal';
    color?: Color;
};

SectionLabel.defaultProps = {
    as: 'div',
};

/*
 * This component is responsible for rendering a 12px all uppercased
 * section label that we use on peep and lead pages.
 */
export function SectionLabel({
    children,
    as: Tag,
    noBottomBorder,
    noBottomMargin,
    htmlFor,
    size = 'normal',
    color,
}: Props) {
    const styleNames = classnames(styles['section-label'], {
        [styles['no-bottom-border']]: noBottomBorder,
        [styles['no-bottom-margin']]: noBottomMargin,
        [styles[`${size}`]]: size,
        [styles.light]: color === 'light',
        [styles.medium]: color === 'medium',
        [styles.dark]: color === 'dark',
        [styles.person]: color === 'person',
        [styles.error]: color === 'error',
        [styles.blue]: color === 'blue',
        [styles.white]: color === 'white',
        [styles.green]: color === 'green',
        [styles['blue-dk']]: color === 'blue-dk',
        [styles['navy-dk']]: color === 'navy-dk',
        [styles.warn]: color === 'warn',
        [styles['ai-purple']]: color === 'ai-purple',
    });

    return (
        // @ts-expect-error
        <Tag htmlFor={htmlFor} className={styleNames}>
            {children}
        </Tag>
    );
}
